import { render, staticRenderFns } from "./Birthday-2k25.vue?vue&type=template&id=1d175396&scoped=true&"
import script from "./Birthday-2k25.vue?vue&type=script&lang=js&"
export * from "./Birthday-2k25.vue?vue&type=script&lang=js&"
import style0 from "./Birthday-2k25.vue?vue&type=style&index=0&id=1d175396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d175396",
  null
  
)

export default component.exports